/* eslint-disable no-underscore-dangle */
import { FIELD_TYPES } from './Field.vue';

const SUPPORTED_TYPES = Object.keys(FIELD_TYPES);

const excludeUndefined = (object) => Object.fromEntries(Object.entries(object)
  .filter((entry) => entry[1] !== undefined));

export default class FieldBuilderUtil {
  static createField(alias) {
    return new FieldBuilderUtil({ alias });
  }

  static size(sm, md, lg, xl) {
    const _set = (val) => (val ? val.toString() : undefined);

    const values = [sm, md, lg, xl].map((v) => _set(v));

    return {
      sm: values[0], md: values[1], lg: values[2], xl: values[3],
    };
  }

  constructor(options = {}) {
    this._properties = {};
    if (options.alias != null) {
      this._properties.alias = options.alias;
    }
    if (options.type != null) {
      this.ofType(options.type);
    }
    if (options.name != null) {
      this.withLabel(options.name);
    }
    if (options.sequence != null) {
      this.withSequence(options.sequence);
    }
    if (options.params != null) {
      this.withParams(options.params);
    }
    if (options.config != null) {
      this.withParams(options.config);
    }
  }

  ofType(type) {
    if (type == null || !SUPPORTED_TYPES.includes(type)) {
      throw new Error(`invalid field type specified: ${type || 'null'}`);
    }
    this.set('type', { name: type });
    return this;
  }

  required() {
    this.set('required', true);
    return this;
  }

  withLabel(label) {
    this.set('name', label);
    return this;
  }

  withSequence(sequence) {
    this.set('sequence', sequence);
    return this;
  }

  withParams(params) {
    this.set('params', { ...excludeUndefined(params) });
    return this;
  }

  withConfig(config) {
    this.set('config', { ...excludeUndefined(config) });
    return this;
  }

  whichDepends(dependencies) {
    this.set('dependency', { ...excludeUndefined(dependencies) });
    return this;
  }

  set(property, value) {
    this._properties[property] = value;
  }

  build() {
    // return a copy of the field properties
    return { ...this._properties };
  }
}
